import { Injectable } from '@angular/core';

export interface ScanProcessingPanoResolution {
    label: string;
    value: {
        panoramaResX: number;
        panoramaResY: number;
    };
}

export interface ScanProcessingOutputFormats {
    name: string;
    label: string;
    option: string;
}

export interface ScanProcessingEdgeNoiseLevel {
    label: string;
    value: number;
}

/**
 * Service with the options for the scan processing
 */
@Injectable({ providedIn: 'root' })
export class ScanProcessingService {
    panoramaResolution: ScanProcessingPanoResolution[] = [
        {
            label: '8192x4096',
            value: {
                panoramaResX: 8192,
                panoramaResY: 4096,
            },
        },
        {
            label: '4096x2048',
            value: {
                panoramaResX: 4096,
                panoramaResY: 2048,
            },
        },
        {
            label: '2048x1024',
            value: {
                panoramaResX: 2048,
                panoramaResY: 1096,
            },
        },
    ];

    scanOutputFormats: ScanProcessingOutputFormats[] = [
        {
            name: 'pointcloud',
            label: 'SCANPROC.POINTCLOUD',
            option: 'processPointcloud',
        },
        {
            name: 'panorama',
            label: 'SCANPROC.PANORAMA',
            option: 'processPanorama',
        },
    ];

    edgeNoiseReductLevels: ScanProcessingEdgeNoiseLevel[] = [
        {
            label: 'SCANPROC.LOW',
            value: 0,
        },
        {
            label: 'SCANPROC.MEDIUM',
            value: 1,
        },
        {
            label: 'SCANPROC.HIGH',
            value: 2,
        },
    ];
}
